// extracted by mini-css-extract-plugin
module.exports = {"bar":"bar_bar_14l_f"};